export default __webpack_public_path__ + "static/media/i-external-green-sm.7544630f.svg";